export const TOKEN_DECIMALS = 5;

export enum Networks {
    BSC = 56,
}

export const DEFAULD_NETWORK = Networks.BSC;
